import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import { getFaq } from '../../lib/apiRequests';

export default function FaqMenu({ onSelectQuestion, onSkip }) {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getFaq()
            .then(data => {
                setCategories(data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, []);

    const handleBack = () => {
        setSelectedCategory(null);
    };

    if (loading) {
        return (
            <Box sx={styles.wrapper}>
                <CircularProgress size={24} sx={{ margin: 'auto' }} />
            </Box>
        );
    }

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.header}>
                {selectedCategory !== null && (
                    <IconButton onClick={handleBack} size="small" sx={{ color: '#6b7b8a' }}>
                        <ArrowBackIcon fontSize="small" />
                    </IconButton>
                )}
                <Box sx={styles.title}>
                    {selectedCategory !== null
                        ? categories[selectedCategory].label
                        : 'What can I help you with?'}
                </Box>
            </Box>

            <Box sx={styles.buttonList}>
                {selectedCategory === null ? (
                    <>
                        {categories.map((cat, idx) => (
                            <Button
                                key={idx}
                                variant="outlined"
                                onClick={() => setSelectedCategory(idx)}
                                sx={styles.button}
                            >
                                {cat.label}
                            </Button>
                        ))}
                        <Button
                            variant="contained"
                            onClick={onSkip}
                            sx={styles.skipButton}
                        >
                            Ask your own question
                        </Button>
                    </>
                ) : (
                    categories[selectedCategory].items.map((item, idx) => (
                        <Button
                            key={idx}
                            variant="outlined"
                            onClick={() => onSelectQuestion(item.question, item.answer)}
                            sx={styles.button}
                        >
                            {item.question}
                        </Button>
                    ))
                )}
            </Box>
        </Box>
    );
}

FaqMenu.propTypes = {
    onSelectQuestion: PropTypes.func.isRequired,
    onSkip: PropTypes.func.isRequired,
};

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: '16px',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '16px',
    },
    title: {
        fontSize: '15px',
        fontWeight: 500,
        color: '#444',
    },
    buttonList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        overflowY: 'auto',
        flex: 1,
    },
    button: {
        textTransform: 'none',
        justifyContent: 'flex-start',
        textAlign: 'left',
        borderColor: '#ddd',
        color: '#444',
        fontSize: '13px',
        padding: '10px 14px',
        borderRadius: '12px',
        '&:hover': {
            borderColor: '#6b7b8a',
            backgroundColor: '#f5f8fa',
        },
    },
    skipButton: {
        textTransform: 'none',
        marginTop: '8px',
        backgroundColor: '#6b7b8a',
        color: '#fff',
        fontSize: '13px',
        padding: '10px 14px',
        borderRadius: '12px',
        '&:hover': {
            backgroundColor: '#5a6a78',
        },
    },
};
